export default __webpack_public_path__ + "static/media/reports-4.757cb5c1.png";